import { render, staticRenderFns } from "./SettingsHeader.vue?vue&type=template&id=2d1186e6&"
import script from "./SettingsHeader.vue?vue&type=script&lang=js&"
export * from "./SettingsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1186e6')) {
      api.createRecord('2d1186e6', component.options)
    } else {
      api.reload('2d1186e6', component.options)
    }
    module.hot.accept("./SettingsHeader.vue?vue&type=template&id=2d1186e6&", function () {
      api.rerender('2d1186e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/SettingsHeader.vue"
export default component.exports